import { Navigate, createRouter, RegisteredRouter } from '@tanstack/react-router';

import Page500 from 'src/sections/error/500-view';

import { rootRoute } from './root';
import { eulaRoute } from './eula';
import { notFoundRoute } from './404';
import { authRouteTree } from './auth';
import { forbiddenRoute } from './403';
import { userRouteTree } from './user';
import { newsRouteTree } from './news';
import { buyersRootTree } from './buyers';
import { indexRoute } from './index-route';
import { markersRouteTree } from './markers';
import { surplusRouteTree } from './surplus';
import { storiesRouteTree } from './stories';
import { productsRouteTree } from './products';
import { invoicesRouteTree } from './invoices';
import { producerRouteTree } from './producers';
import { reportingRouteTree } from './reporting';
import { supplierRouteTree } from './distributors';
import { dataMapperRouteTree } from './data-mapper';
import { resetPasswordRoute } from './reset-password';
import { buyerOrdersRouteTree } from './buyer-orders';
import { forgotPasswordRoute } from './forgot-password';
import { userManagementRouteTree } from './user-management';
import { insufficientRoleRoute } from './insufficient-role';
import { seasonalCalendarRouteTree } from './seasonal-calendar';
import { mfaResetRequestRoute, mfaResetConfirmRoute } from './mfa-reset';
import { orderIssuesRouteTree, orderIssuesAnonymousRouteTree } from './order-issues';
import {
  priceBulkActionsRouteTree,
  productsBulkActionsRouteTree,
  bespokePriceBulkActionsRouteTree,
} from './products-bulk-actions';

const routeTree = rootRoute.addChildren([
  authRouteTree,
  indexRoute,
  notFoundRoute,
  forbiddenRoute,
  insufficientRoleRoute,
  eulaRoute,
  forgotPasswordRoute,
  mfaResetRequestRoute,
  mfaResetConfirmRoute,
  resetPasswordRoute,
  userManagementRouteTree,
  buyerOrdersRouteTree,
  productsRouteTree,
  producerRouteTree,
  supplierRouteTree,
  buyersRootTree,
  userRouteTree,
  newsRouteTree,
  markersRouteTree,
  seasonalCalendarRouteTree,
  orderIssuesRouteTree,
  orderIssuesAnonymousRouteTree,
  surplusRouteTree,
  reportingRouteTree,
  invoicesRouteTree,
  productsBulkActionsRouteTree,
  priceBulkActionsRouteTree,
  bespokePriceBulkActionsRouteTree,
  dataMapperRouteTree,
  storiesRouteTree,
]);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof mainRouter;
  }
}

export type ValidRoutePath = keyof RegisteredRouter['routesByPath'];

// Create the router instance
export const mainRouter = createRouter({
  routeTree,
  defaultErrorComponent: () => <Page500 />,
  defaultNotFoundComponent: () => <Navigate to="/404" />,
});
